import { TrackerTranslations } from './types';

export const deTranslations: TrackerTranslations = {
    header: "Ausgewählte Krankheiten",
    noDiseases: "Keine Krankheiten ausgewählt"
};